// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lkpwnNMzFSQclLKUj-ayx","groupsList":"_1IL8LeKxK3f4pcjFMj76pB"};